"use strict";

define('view/report/report.filter.bar',['underscore', 'backbone', 'marionette', 'uikit/uikit', '../list.pagination', 'libs/visual.search.helper', './visualsearch.report', 'model/paginate', 'templates', 'uikit/elements/input', 'uikit/modules/loader', 'uikit/modules/dimmer', 'uikit/elements/text', 'uikit/collections/table', 'uikit/collections/breadcrumb'], function (_, Backbone, Mn, UIKit, ListPagination, VisualSearchHelper, VisualSearchReport, Paginate, Templates) {
  var ReportFilterBarView = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    useInjector: true,
    template: Templates.IRB['report.filter.bar'],
    options: {
      search: true,
      visualsearch: true,
      breadcrumbs: false,
      header: true,
      searchSegmentColor: 'tertiary',
      searchSegmentAttached: 'top'
    },
    update: {
      search: false,
      visualsearch: false,
      breadcrumbs: false,
      header: false
    },
    ui: {
      bottomSegment: '.bottom-segment'
    },
    internalViews: {
      visualsearchView: VisualSearchReport,
      pagination: ListPagination
    },
    initialize: function initialize() {
      UIKit.ComponentMixin.initialize.apply(this, arguments);
    },
    serializeData: function serializeData() {
      var data = UIKit.ComponentMixin.serializeData.apply(this, arguments);
      data.headerOrBreadcrumbs = data.header || data.breadcrumbs;
      return data;
    },
    addLeftHeaderItem: function addLeftHeaderItem() {
      this.headerLeftContainer.add.apply(this.headerLeftContainer, arguments);
      return this;
    },
    addRightHeaderItem: function addRightHeaderItem() {
      this.headerRightContainer.add.apply(this.headerRightContainer, arguments);
      return this;
    },
    addLeftToolbarItem: function addLeftToolbarItem() {
      this.toolbarLeftContainer.add.apply(this.toolbarLeftContainer, arguments);
      return this;
    },
    addRightToolbarItem: function addRightToolbarItem() {
      this.toolbarRightContainer.add.apply(this.toolbarRightContainer, arguments);
      return this;
    },
    setupFilterDefaults: function setupFilterDefaults(attrs) {
      _.defaults(this.spfHelper.filter.attributes, attrs);
      return this;
    },
    setupPageSizes: function setupPageSizes(sizes) {
      if (!this.spfHelper) {
        return this;
      }
      var pageSizeDropdown = this.pagination.pageSizeDropdown;
      this.pagination.visible = true;
      pageSizeDropdown.visible = true;
      pageSizeDropdown.collection = new Backbone.Collection(sizes || [{
        size: 5
      }, {
        size: 10
      }, {
        size: 25
      }, {
        size: 50
      }]);
      pageSizeDropdown.childBindings.text = 'size';
      function applyPageSize() {
        var selectedItem = pageSizeDropdown.collection.findWhere({
          size: this.spfHelper.paginate.get(Paginate.SIZE)
        });
        pageSizeDropdown.text = selectedItem.get('size') + ' per page';
        pageSizeDropdown.value = selectedItem;
      }
      function applyItemCount() {
        var model = this.spfHelper.paginate,
          page = model.get(Paginate.PAGE),
          totalItem = Number(model.get(Paginate.TOTAL_ITEMS)),
          itemStartIndex = (Number(page) - 1) * Number(model.get(Paginate.SIZE)) + 1,
          itemEndIndex = Math.min(Number(model.get(Paginate.TOTAL_ITEMS)), itemStartIndex + Number(model.get(Paginate.SIZE)) - 1),
          title = String(Math.min(itemStartIndex, totalItem)) + '-' + String(itemEndIndex) + ' of ' + String(totalItem);
        if (_.isNaN(itemStartIndex) || _.isNaN(itemEndIndex)) {
          this.pagination.title.text = '';
        } else {
          this.pagination.title.text = title;
        }
      }
      applyPageSize.call(this);
      this.listenTo(this.spfHelper.paginate, 'change:' + Paginate.SIZE, applyPageSize).listenTo(this.spfHelper.paginate, 'change:' + Paginate.TOTAL_ITEMS + ' change:' + Paginate.SIZE + ' change:' + Paginate.PAGE, applyItemCount);
      this.listenTo(pageSizeDropdown, 'change:value', function () {
        if (pageSizeDropdown.value) {
          this.spfHelper.paginate.set(Paginate.SIZE, pageSizeDropdown.value.get(Paginate.SIZE));
        } else {
          this.spfHelper.paginate.unset(Paginate.SIZE);
        }
      });
      return this;
    },
    setupPaginate: function setupPaginate() {
      if (!this.spfHelper) {
        return this;
      }
      var pageNumbers = this.pagination.pageNumbers;
      this.pagination.visible = true;
      pageNumbers.visible = true;
      pageNumbers.model = this.spfHelper.paginate;
      pageNumbers.bindings.currentPage = Paginate.PAGE;
      pageNumbers.bindings.totalPages = Paginate.TOTAL_PAGES;
      return this;
    },
    getSPFHelperOptions: function getSPFHelperOptions() {
      return _.extend({}, this._SPFHelperOptions, Mn._getValue(this.SPFHelperOptions, this));
    },
    setupSearch: function setupSearch(initialSearch, placeholder) {
      this.searchView.value = initialSearch;
      this.searchView.placeholder = placeholder || 'Click to search';
      this.searchView.visible = true;
      return this;
    },
    setupVisualSearch: function setupVisualSearch(fields, state, selectedFilters) {
      this.fields = fields;
      this.setupFilters(_.pluck(fields, 'name'));
      this.spfHelper.filter.set(selectedFilters);
      this.visualsearchView.visible = true;
      if (state) {
        this.setupState(state);
      }
      if (this._vsEventBus) {
        this._vsEventBus.stopListening().off();
      }
      this._vsEventBus = VisualSearchHelper.bindFilterVisualSearch(this.visualsearchView, this.spfHelper.filter, this.fields);
      return this;
    },
    setupFilters: function setupFilters(filters) {
      this.filters = filters;
      return this;
    },
    setupState: function setupState(state) {
      if (this._stateBindHandle) {
        this._stateBindHandle.unbind();
        this._stateBindHandle = null;
      }
      if (!this.spfHelper || !this.filters) {
        return this;
      }
      this._stateBindHandle = this.spfHelper.setupState(state, this.filters);
      return this;
    }
  });
  return ReportFilterBarView;
});

